import React, { useCallback, useState } from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY } from '@/utils/config';

interface MapProps {
  children: React.ReactNode[];
  mapZoomLevel: number;
  mapCenter: {
    lat: number;
    lng: number;
  };
}

const Map = ({ children, mapZoomLevel, mapCenter }: MapProps) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  const [, setMap] = useState(null);

  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  return (
    isLoaded && (
      <GoogleMap
        mapContainerStyle={{
          width: '100%',
          height: '100%',
        }}
        center={{
          lat: mapCenter.lat,
          lng: mapCenter.lng,
        }}
        zoom={3}
        clickableIcons={false}
        options={{
          clickableIcons: false,
          draggable: true,
          draggableCursor: 'grab',
          draggingCursor: 'grabbing',
          fullscreenControl: false,
          gestureHandling: 'greedy',
          mapTypeControl: false,
          mapTypeControlOptions: {},
          minZoom: 3,
          maxZoom: 12,
          scrollwheel: false,
          streetViewControl: false,
          zoom: mapZoomLevel,
          zoomControl: true,
          zoomControlOptions: {},
        }}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {children}
      </GoogleMap>
    )
  );
};

export default React.memo(Map);
